<template>
  <a-modal
    width="600px"
    title="选择原料"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-table
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange:onSelectChange}" 
      :pagination="pagination"
      :columns="materialSelectColumns"
      :data-source="materialList"/>
  </a-modal>
</template>

<script>
import {materialSelectColumns} from '../Columns'

export default {
  props:['visible','materialList'],
  data(){
    return{
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.pagination.pageSize = pageSize;
        }, //选择页数
        onShowSizeChange: ( current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
        }, //每页多少条
      },
      materialSelectColumns,
      selectedRowKeys: [],
      showRow:[],
    }
  },
  watch:{
    materialList(){
      this.materialList.forEach((element,index) => {
        element.key = index
      })
    }
  },
  methods:{
    handleOk() {
      this.$emit('isShow', false)
      this.selectedRowKeys=[]
      this.$emit('getSelect', this.showRow)
      setTimeout(() => {
        this.pagination.current = 1
        this.pagination.pageSize = 10
      }, 200);
    },
    handleCancel() {
      this.$emit('isShow', false)
      this.selectedRowKeys=[]
      setTimeout(() => {
        this.pagination.current = 1
        this.pagination.pageSize = 10
      }, 200);
    },
    onSelectChange(selectedRowKeys, record) {
      this.selectedRowKeys = selectedRowKeys
      this.showRow = record
    }
  }
}
</script>

<style>

</style>